"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const modal_1 = require("src/context/modal");
const attachment_image_1 = __importDefault(require("../attachment-image"));
const option_1 = __importDefault(require("./option"));
const b = b_1.default.with('choice');
function Options(props) {
    const { options, multipleChoice, questionIndex, handleClickOption, limitReached } = props;
    const { displayHiddenQuestions } = (0, modal_1.useModalContext)();
    return ((0, jsx_runtime_1.jsx)(react_2.Fragment, { children: options.map((option, index) => {
            const { id: value, label = '', checked, visible, attachments = [], disabled = !checked && limitReached } = option;
            if (visible === false && !displayHiddenQuestions) {
                return null;
            }
            const id = `q${questionIndex}o${index}`;
            const controlProps = {
                id,
                value,
                label,
                checked,
                handleClickOption,
                multipleChoice,
                visible,
                disabled
            };
            return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [(0, jsx_runtime_1.jsx)(option_1.default, Object.assign({}, controlProps)), Boolean(attachments.length) && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('attachments-wrapper') }, { children: attachments.map(attachment => ((0, jsx_runtime_1.jsx)(attachment_image_1.default, { url: attachment.url }, attachment.url))) })))] }, id));
        }) }));
}
exports.default = Options;
